import React from 'react';
import cx from 'classnames';

import numberUtils from 'app/shared/utils/numberUtils';

import './style.scss';

const createBucket = () => ({
    price: 0,
    squareFeet: 0,
    count: 0,
});

const mapData = (propertyModelData) => {
    const roomMapping = {};
    propertyModelData.forEach((propertyModels) => {
        propertyModels.forEach((propertyModel) => {
            const {
                numBedrooms,
                numFullBaths,
                highPrice,
                squareFeet,
                numHalfBaths,
            } = propertyModel;
            if (!highPrice) return;
            if (!squareFeet) return;
            const totalBaths = numFullBaths + (numHalfBaths || 0);
            roomMapping[numBedrooms] = roomMapping[numBedrooms] || {};
            roomMapping[numBedrooms][totalBaths]
                = roomMapping[numBedrooms][totalBaths] || createBucket();
            roomMapping[numBedrooms][totalBaths].count += 1;
            roomMapping[numBedrooms][totalBaths].price += highPrice;
            roomMapping[numBedrooms][totalBaths].squareFeet += squareFeet;
        });
    });
    return roomMapping;
};

const getTargetPrice = (data, bedsKey, bathsKey) => {
    if (data[bedsKey] && data[bedsKey][bathsKey]) {
        const rowData = data[bedsKey][bathsKey];
        return numberUtils.asCurrencyWithDefault(rowData.price / rowData.count, 'N/A');
    }
    return 'Not Listed';
};

const getTargetSquareFeet = (data, bedsKey, bathsKey) => {
    if (data[bedsKey] && data[bedsKey][bathsKey]) {
        const rowData = data[bedsKey][bathsKey];
        return numberUtils.asCurrencyWithDefault(rowData.squareFeet / rowData.count, 'N/A');
    }
    return 'Not Listed';
};

const formatRoom = roomKey => (roomKey > 0 ? `${roomKey} BR` : 'Studio');

const CompareGrid = ({ properties }) => {
    const models = properties.map((prop => prop.models));
    const mappedData = mapData(models);
    const targetMap = mapData(models.slice(0, 1));
    const renderData = () => {
        const rows = [];
        // eslint-disable-next-line guard-for-in
        for (const bedsKey in mappedData) {
            const bedsGroup = mappedData[bedsKey];
            let rowCounter = 0;
            // eslint-disable-next-line guard-for-in
            for (const bathsKey in bedsGroup) {
                const rowData = bedsGroup[bathsKey];
                rows.push(
                    <div
                        key={`${bedsKey}-${bathsKey}`}
                        className={cx('CompareGrid-row', {
                            'CompareGrid-row-separator': rowCounter === Object.keys(bedsGroup).length - 1,
                        })}
                    >
                        <div className="CompareGrid-cell">
                            {formatRoom(bedsKey)}
                        </div>
                        <div className="CompareGrid-cell">
                            {`${bathsKey} BA`}
                        </div>
                        <div className="CompareGrid-cell UserPropertyColumn">
                            {getTargetPrice(targetMap, bedsKey, bathsKey)}
                        </div>
                        <div className="CompareGrid-cell UserPropertyColumn">
                            {getTargetSquareFeet(targetMap, bedsKey, bathsKey)}
                        </div>
                        <div className="CompareGrid-cell">
                            {numberUtils.asCurrencyWithDefault(rowData.price / rowData.count, 'N/A')}
                        </div>
                        <div className="CompareGrid-cell">
                            {numberUtils.asCurrencyWithDefault(rowData.squareFeet / rowData.count, 'N/A')}
                        </div>
                    </div>
                );
                rowCounter += 1;
            }
        }
        return rows;
    };

    return (
        <div className="CompareGrid">
            <div className="CompareGrid-row">
                <div className="CompareGrid-cell CompareGrid-cell-configuration CompareGrid-2">
                    Configuration
                </div>
                <div className="CompareGrid-cell CompareGrid-cell-header UserPropertyColumn">
                    Avg. Price
                </div>
                <div className="CompareGrid-cell CompareGrid-cell-header UserPropertyColumn">
                    Avg. Price/Sq ft
                </div>
                <div className="CompareGrid-cell CompareGrid-cell-header">
                    Avg. Price
                </div>
                <div className="CompareGrid-cell CompareGrid-cell-header">
                    Avg. Price/Sq ft
                </div>
            </div>
            {renderData()}
        </div>
    );
};

export default CompareGrid;
